<div
  class="bg-m0 flex h-full w-full min-w-[2px] select-none flex-col items-center justify-center rounded shadow"
  *ngIf="
    nav?.needValidate === true ||
    (repo &&
      repo.conflicts.length === 0 &&
      struct &&
      struct.errors.length === 0 &&
      !secondFileNodeId)
  "
>
  <div
    class="flex flex-col items-center justify-center"
    *ngIf="nav?.needValidate === true"
  >
    <div class="text-a500 flex h-14 flex-row items-end">
      <m-alert-ring></m-alert-ring>
    </div>

    <div class="mt-2 text-xl"> Validation is required </div></div
  >

  <div
    *ngIf="
      nav?.needValidate === false &&
      repo &&
      repo.conflicts.length === 0 &&
      struct &&
      struct.errors.length === 0 &&
      !secondFileNodeId
    "
    class="flex flex-col items-center justify-center"
  >
    <div class="h-12">
      <m-completed-ring></m-completed-ring>
    </div>
    <div class="mt-4 text-xl"> Mprove Files are valid </div>
  </div>

  <div
    tp="FileEditor role is required to validate files"
    [tpIsEnabled]="isEditor === false"
  >
    <button
      *ngIf="nav?.needValidate === true"
      data-cy="filesRightValidateButton"
      class="mt-7 h-11 rounded border px-5 py-2 text-lg focus:outline-none"
      type="button"
      [ngClass]="{
        'bg-m600 border-m600 text-m0': isEditor === true && needSave === false,
        'border-s300 text-s400 cursor-default':
          isEditor === false || needSave === true
      }"
      (click)="validate()"
      [disabled]="isEditor === false || needSave === true"
      >Validate Files</button
    >

    <button
      *ngIf="
        nav?.needValidate === false && nav?.repoType !== repoTypeEnum.Production
      "
      type="button"
      data-cy="filesRightRevalidateButton"
      class="mt-5 h-11 flex-shrink-0 select-none rounded border px-5 py-2 text-lg focus:outline-none"
      [ngClass]="{
        'border-s400 text-s500 hover:bg-gray-50':
          isEditor === true && needSave === false,
        'border-s300 text-s400 cursor-default':
          isEditor === false || needSave === true
      }"
      (click)="validate()"
      [disabled]="isEditor === false || needSave === true"
      >Validate Files</button
    >
  </div>
</div>

<m-repo-conflicts
  *ngIf="nav?.needValidate === false && repo && repo.conflicts.length > 0"
  [isEditor]="isEditor"
  [needSave]="needSave"
  [isProduction]="nav?.repoType === repoTypeEnum.Production"
  (validateClick)="validate()"
  class="flex w-full"
></m-repo-conflicts>

<m-blockml-errors
  *ngIf="
    nav?.needValidate === false &&
    repo &&
    repo.conflicts.length === 0 &&
    struct &&
    struct.errors.length > 0
  "
  [isEditor]="isEditor"
  [needSave]="needSave"
  [isProduction]="nav?.repoType === repoTypeEnum.Production"
  (validateClick)="validate()"
  class="flex w-full"
></m-blockml-errors>

<div *ngIf="repo$ | async"></div>
<div *ngIf="struct$ | async"></div>
<div *ngIf="needSave$ | async"></div>
<div *ngIf="nav$ | async"></div>
<div *ngIf="isEditor$ | async"></div>
<div *ngIf="secondFileNodeId$ | async"></div>
